import Swal from 'sweetalert2'

const warning = (text) => {
    return new Promise((resolve) => {
        Swal.fire({
            icon: "error",
            title: "Erreur",
            text: text,
        });
    });
};

export default warning;
